// Hook to detect when component has hydrated on client

import { useEffect, useState } from "react";

export default function useHasHydrated() {
  const [hasHydrated, setHasHydrated] = useState(false);

  useEffect(() => {
    setHasHydrated(true);
  }, []);

  return hasHydrated;
}
